// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let Avatar = require("./Avatar.bs.js");
let ButtonsV5 = require("./ButtonsV5.bs.js");
let ViewStack = require("../../../reason/common/ViewStack.bs.js");
let Belt_Array = require("@rescript/runtime/lib/js/Belt_Array.js");
let Responsive = require("../../../uikit/reason/helpers/Responsive.bs.js");
let UserSession = require("../../../reason/common/UserSession/UserSession.bs.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let ErrorComponent = require("./ErrorComponent.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let Types__Attachment = require("../../../reason/common/types/Types__Attachment.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let WarningSection__Jsx3 = require("../../../uikit/reason/atoms/Sections/WarningSection__Jsx3.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let ConversationsSection__Common = require("./ConversationsSection__Common.bs.js");
let ConversationsSection__MessageInputForm = require("./ConversationsSection__MessageInputForm.bs.js");
let ConversationsSection__ConversationMessageArea = require("./ConversationsSection__ConversationMessageArea.bs.js");
let ConversationsSectionReplyInputMutation_graphql = require("../../../__generated__/ConversationsSectionReplyInputMutation_graphql.bs.js");
let ConversationsSection__UnsupportedAttachmentsDialog = require("./ConversationsSection__UnsupportedAttachmentsDialog.bs.js");
let ConversationsSectionReplyInput_conversation_graphql = require("../../../__generated__/ConversationsSectionReplyInput_conversation_graphql.bs.js");
let ConversationsSectionReplyInput_DeactivatedConversationWarning_conversation_graphql = require("../../../__generated__/ConversationsSectionReplyInput_DeactivatedConversationWarning_conversation_graphql.bs.js");

let convertFragment = ConversationsSectionReplyInput_DeactivatedConversationWarning_conversation_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationsSectionReplyInput_DeactivatedConversationWarning_conversation_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationsSectionReplyInput_DeactivatedConversationWarning_conversation_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ConversationsSectionReplyInput_DeactivatedConversationWarning_conversation_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ConversationsSectionReplyInput_DeactivatedConversationWarning_conversation_graphql.node, convertFragment, fRef);
}

let Fragment_membershipStatusV5_decode = ConversationsSectionReplyInput_DeactivatedConversationWarning_conversation_graphql.Utils.membershipStatusV5_decode;

let Fragment_membershipStatusV5_fromString = ConversationsSectionReplyInput_DeactivatedConversationWarning_conversation_graphql.Utils.membershipStatusV5_fromString;

let Fragment = {
  membershipStatusV5_decode: Fragment_membershipStatusV5_decode,
  membershipStatusV5_fromString: Fragment_membershipStatusV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ConversationsSection__ReplyInput$DeactivatedConversationWarning(props) {
  let conversation = RescriptRelay_Fragment.useFragment(ConversationsSectionReplyInput_DeactivatedConversationWarning_conversation_graphql.node, convertFragment, props.conversation);
  let deactivatedUserDisplayName = Stdlib_Array.filterMap(Stdlib_Array.filterMap(conversation.participants.edges, x => x), x => {
      let match = x.node;
      if (match.__typename !== "Agent") {
        return;
      }
      let tmp = match.membershipStatus;
      if (tmp === "TERMINATED") {
        return match.displayName;
      }
    })[0];
  let deactivatedUserName = Stdlib_Option.getOr(deactivatedUserDisplayName, "your recipient");
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx(WarningSection__Jsx3.make, {
      children: "You can't reply as " + (deactivatedUserName + " no longer has an active subscription on TAN")
    }),
    className: "w-full"
  });
}

let DeactivatedConversationWarning = {
  Fragment: Fragment,
  make: ConversationsSection__ReplyInput$DeactivatedConversationWarning
};

let convertFragment$1 = ConversationsSectionReplyInput_conversation_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationsSectionReplyInput_conversation_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationsSectionReplyInput_conversation_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ConversationsSectionReplyInput_conversation_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(ConversationsSectionReplyInput_conversation_graphql.node, convertFragment$1, fRef);
}

let Fragment_conversationVisibilityV5_decode = ConversationsSectionReplyInput_conversation_graphql.Utils.conversationVisibilityV5_decode;

let Fragment_conversationVisibilityV5_fromString = ConversationsSectionReplyInput_conversation_graphql.Utils.conversationVisibilityV5_fromString;

let Fragment$1 = {
  conversationVisibilityV5_decode: Fragment_conversationVisibilityV5_decode,
  conversationVisibilityV5_fromString: Fragment_conversationVisibilityV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

let convertVariables = ConversationsSectionReplyInputMutation_graphql.Internal.convertVariables;

let convertResponse = ConversationsSectionReplyInputMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = ConversationsSectionReplyInputMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, ConversationsSectionReplyInputMutation_graphql.node, convertResponse, convertWrapRawResponse);

let use$2 = RescriptRelay_Mutation.useMutation(convertVariables, ConversationsSectionReplyInputMutation_graphql.node, convertResponse, convertWrapRawResponse);

let Mutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use$2
};

function ConversationsSection__ReplyInput(props) {
  let targetConversationMessagesConnectionId = props.targetConversationMessagesConnectionId;
  let __showVisibilityInfo = props.showVisibilityInfo;
  let __withAvatar = props.withAvatar;
  let withAvatar = __withAvatar !== undefined ? __withAvatar : true;
  let showVisibilityInfo = __showVisibilityInfo !== undefined ? __showVisibilityInfo : true;
  let conversation = RescriptRelay_Fragment.useFragment(ConversationsSectionReplyInput_conversation_graphql.node, convertFragment$1, props.conversation);
  let match = React.useState(() => []);
  let setUnsupportedFiles = match[1];
  let match$1 = use$2();
  let mutate = match$1[0];
  let agent = UserSession.useAgentInfo();
  let mutate$1 = (state, reset, notifyOnFailure, notifyOnSuccess) => {
    let match = Belt_Array.partition(state.attachments, Types__Attachment.isImage);
    mutate({
      connections: [targetConversationMessagesConnectionId],
      input: {
        conversationId: conversation.id,
        files: match[1].map(ConversationsSection__Common.attachmentToInput),
        images: match[0].map(ConversationsSection__Common.attachmentToInput),
        text: state.text
      }
    }, undefined, undefined, undefined, (response, errors) => {
      let match = response.replyToConversationV5;
      if (match === undefined) {
        return notifyOnFailure();
      }
      switch (match.__typename) {
        case "ConversationReply" :
          reset();
          return notifyOnSuccess(undefined);
        case "ConversationIsReadOnlyError" :
        case "__unselected" :
          return notifyOnFailure();
      }
    }, undefined, undefined);
  };
  let match$2 = ConversationsSection__MessageInputForm.useWithAttachments(mutate$1, files => setUnsupportedFiles(param => files));
  let form = match$2[0];
  let submitDisabled = form.submitting || !form.valid();
  let tmp;
  if (conversation.readOnly) {
    tmp = JsxRuntime.jsx(ConversationsSection__ReplyInput$DeactivatedConversationWarning, {
      conversation: conversation.fragmentRefs
    });
  } else {
    let match$3 = conversation.visibility;
    let tmp$1;
    tmp$1 = showVisibilityInfo ? (
        match$3 === "PRIVATE" ? "Reply privately" : "Reply publicly"
      ) : "Reply";
    let match$4 = conversation.visibility;
    let tmp$2;
    tmp$2 = showVisibilityInfo ? (
        match$4 === "PRIVATE" ? "Private reply" : "Public reply"
      ) : "";
    let match$5 = form.status;
    let tmp$3;
    tmp$3 = typeof match$5 !== "object" || match$5.TAG !== "SubmissionFailed" ? null : JsxRuntime.jsx(ErrorComponent.make, {
        message: "An error ocurred while sending the message"
      });
    tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [
        withAvatar ? JsxRuntime.jsx(JsxRuntime.Fragment, {
            children: JsxRuntime.jsx(Avatar.make, {
              name: agent.firstName + ` ` + agent.lastName,
              src: UserSession.Agent.avatarUrl(agent, undefined, undefined),
              size: 1
            })
          }) : null,
        JsxRuntime.jsxs("form", {
          children: [
            JsxRuntime.jsx(ConversationsSection__ConversationMessageArea.make, {
              form: form,
              attachmentsManager: match$2[1],
              inputRef: props.inputRef,
              submitButtons: JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
                disabled: submitDisabled,
                children: tmp$1
              }),
              focusOnMount: props.focusOnMount,
              placeholder: tmp$2
            }),
            tmp$3
          ],
          className: "w-full",
          onSubmit: e => {
            e.preventDefault();
            form.submit();
          }
        })
      ]
    });
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx(ConversationsSection__UnsupportedAttachmentsDialog.make, {
        files: match[0],
        onDismiss: () => setUnsupportedFiles(param => [])
      }),
      JsxRuntime.jsx(ViewStack.make, {
        space: Responsive.make({
          NAME: "px",
          VAL: "p6"
        }, {
          NAME: "px",
          VAL: "p10"
        }, undefined, undefined, undefined, undefined, undefined),
        width: {
          NAME: "percent",
          VAL: "p100"
        },
        alignItems: "flexStart",
        flexDirection: "row",
        flexGrow: 1,
        children: tmp
      })
    ]
  });
}

let Buttons;

let Commons;

let ConversationMessageForm;

let ConversationMessageArea;

let SendMessageButtons;

let make = ConversationsSection__ReplyInput;

exports.Buttons = Buttons;
exports.Commons = Commons;
exports.ConversationMessageForm = ConversationMessageForm;
exports.ConversationMessageArea = ConversationMessageArea;
exports.SendMessageButtons = SendMessageButtons;
exports.DeactivatedConversationWarning = DeactivatedConversationWarning;
exports.Fragment = Fragment$1;
exports.Mutation = Mutation;
exports.make = make;
/* commitMutation Not a pure module */
